module.exports = __webpack_public_path__ + "static/img/rrs2020.9722d6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/thumbs/rrs2020.png
// module id = O4si
// module chunks = 0